import React from "react";
import { PasswordGate } from "../../components/PasswordGate";
import { VolunteerPage as VolunteerPageInner } from "./VolunteerPage";

export const VolunteerPage = () => (
  <PasswordGate storageKey="volunteer_unlocked">
    <VolunteerPageInner />
  </PasswordGate>
);
